document.addEventListener('DOMContentLoaded', function () {
  const target = document.querySelector('#product-grid-Pagination');
  if (target) {
    let isLoading = false;
    window.observer1 = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting && !isLoading) {
          const btn = document.querySelector('#product-grid-Pagination .btn');
          if (btn) {
            isLoading = true;
            btn.click();
          }
        }
      });
    });

    window.observer1.observe(target);
    window.onClickCollectionPagination = async (link, event) => {
      event.preventDefault();

      link.style.width = `${link.offsetWidth}px`;
      link.style.height = `${link.offsetHeight}px`;
      link.innerHTML = `
         
        <div class="st-results-loader">
          <div class="result-loading" style="text-align: center">
          </div>
        </div>

      `;
      const response = await fetch(link.getAttribute('href'));
      const data = await response.text();
      const parser = new DOMParser();
      const newDocument = parser.parseFromString(data, 'text/html');
      document
        .querySelector('#product-grid')
        .insertAdjacentHTML('beforeend', newDocument.querySelector('#product-grid').innerHTML);

      document
        .querySelector('#product-grid-Pagination')
        .replaceWith(newDocument.querySelector('#product-grid-Pagination'));

      window.observer1.observe(document.querySelector('#product-grid-Pagination'));
      const customEvent2 = new CustomEvent('st.collection.paginated');
      window.dispatchEvent(customEvent2);
      isLoading = false;
    };
  }
});